import { render, staticRenderFns } from "./CentralAlertas.vue?vue&type=template&id=d5ff2128&scoped=true&lang=pug"
import script from "./CentralAlertas.vue?vue&type=script&lang=js"
export * from "./CentralAlertas.vue?vue&type=script&lang=js"
import style0 from "./CentralAlertas.vue?vue&type=style&index=0&id=d5ff2128&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d5ff2128",
  null
  
)

export default component.exports